import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";

export default function DynamicBreadcrumb() {
  const location = useLocation();
  
  const pathNameMap = {
    '': 'Home',
    'ingredients': 'Ingredients',
    'tradenames': 'Trade Names',
    'manufacturers': 'Manufacturers',
    'about': 'About Us',
    'contact': 'Contact',
    'privacy': 'Privacy Policy',
    'terms': 'Terms & Conditions'
  };
  
  const formatSegmentName = (segment) => {
    const decodedSegment = decodeURIComponent(segment);
    
    return decodedSegment
      .replace(/-/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  
  const generateBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(segment => segment);
    const breadcrumbs = [];
    
    breadcrumbs.push({
      path: '/',
      label: 'Home',
      isActive: pathSegments.length === 0
    });
    
    let currentPath = '';
    
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      
      let label;
      
      if (pathNameMap[segment]) {
        label = pathNameMap[segment];
      } else {
        label = formatSegmentName(segment);
      }
      
      breadcrumbs.push({
        path: currentPath,
        label,
        isActive: index === pathSegments.length - 1
      });
    });
    
    return breadcrumbs;
  };
  
  const breadcrumbs = generateBreadcrumbs();
  
  if (breadcrumbs.length <= 1) {
    return null;
  }
  
  return (
    <div className="mb-4">
      <nav aria-label="breadcrumb">
        <ol className="flex flex-wrap items-center">
          {breadcrumbs.map((item, index) => (
            <React.Fragment key={item.path}>
              {index > 0 && (
                <li className="mx-1 text-secondary/60">
                  <FiChevronRight className="size-3" />
                </li>
              )}
              <li>
                {item.isActive ? (
                  <span className="font-medium text-14 font-text text-secondary">
                    {item.label}
                  </span>
                ) : (
                  <Link 
                    to={item.path}
                    className="transition-colors text-14 font-text text-secondary/70 hover:text-primary"
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            </React.Fragment>
          ))}
        </ol>
      </nav>
    </div>
  );
} 